import React, { useEffect, useState, useRef } from "react";

import { useToast } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";

import { FiFileText } from "react-icons/fi";
import Context from "../../Context";

import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import constant, { statuses } from "../../constants";
import { CSVLink } from "react-csv";
import { thaiDate } from "../../util";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportVerifiedUser = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs } = Context();
  const [orders, setOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [summary, setSummary] = useState(false);
  const [verifiedUsers, setVerifiedUser] = useState(false);
  const [loading, setLoading] = useState(false);

  const [roundDate, setRoundDate] = useState(configs.roundDate);
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  useEffect(() => {
    countUserVerified();

    getUsers();
  }, [roundDate]);
  const getUsers = async (queries = []) => {
    setLoading(true);
    const result = await callApi(
      "users-getAll",
      {
        queries: [["verifiedId", "verified"]],
        limit: 100000,
        orderBy: ["createdAt", "desc"],
      },
      {
        notShowLoading: true,
      },
    );

    const orders = await getOrders();

    result.sort((a, b) => {
      const dateA = new Date(a.dob);
      const dateB = new Date(b.dob);

      // Compare months (0-11)
      if (dateA.getMonth() !== dateB.getMonth()) {
        return dateA.getMonth() - dateB.getMonth();
      }
      // If months are equal, compare days
      return dateA.getDate() - dateB.getDate();
    });
    setVerifiedUser(
      result.map((user) => {
        return {
          ...user,
          vipOrder: orders.filter((order) => order.userData.userId === user.id),
        };
      }),
    );

    setLoading(false);
  };
  const getOrders = async (queries = []) => {
    const result = await callApi(
      "coupons-getAllCouponOrders",
      {
        queries: [["coupon.vip", true]],
        roundDate: false,
        limit: 10000,
        orderBy: ["createdAt", "desc"],
      },
      { notShowLoading: true },
    );

    return result;
  };

  const countUserVerified = async () => {
    setLoading(true);

    const data = await callApi(
      "utils-countUserVerified",
      {},
      { notShowLoading: true },
    );

    setLoading(false);

    setSummary(data);
  };

  const handleDownload = async () => {
    const csvData = [
      [`รานงานสรุปผู้ใช้_ยืนยันตัวตน_${thaiDate()}`],
      ["", "จำนวน"],
      ["ผู้ใช้ทั้งหมด", summary.all],
      ["บัญชีผู้ใช้ยืนยันตัวตนด้วย OTP", summary.activated],
      ["บัญชีผู้ใช้รอการยืนยันตัวตนด้วยบัตรประชาชน", summary.pending],
      ["บัญชีผู้ใช้ยืนยันตัวตนด้วยบัตรประชาชน", summary.verified],
    ];

    setCsvData(csvData);
    setCsvFileName(`รานงานสรุปผู้ใช้_ยืนยันตัวตน_${thaiDate()}.csv`);
  };

  return (
    <div className="h-fit w-full max-w-[1700px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รานงานสรุปผู้ใช้ยืนยันตัวตน"
        icon={<FiFileText className="text-blue" />}
      />

      {/* <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">รานงานสรุปผู้ใช้ยืนยันตัวตน</p>
        </div>

        <button
          disabled={!summary.status}
          className="flex items-center m-3 justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
          onClick={() => {
            handleDownload();
          }}
        >
          ดาวโหลด
        </button>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div> */}
      <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
          <p className="font-semibold ">รานงานสรุปผู้ใช้</p>
        </div>
        {summary ? (
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className=""></TableHead>
                <TableHead className="text-right">จำนวน</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              <TableRow>
                <TableCell className={` font-semibold`}>
                  บัญชีผู้ใช้ทั้งหมด
                </TableCell>
                <TableCell className={`text-right font-semibold`}>
                  {summary.all.toLocaleString() || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={` font-semibold`}>
                  บัญชีผู้ใช้ยืนยันตัวตนด้วย OTP
                </TableCell>
                <TableCell className={`text-right font-semibold`}>
                  {summary.activated.toLocaleString() || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={` font-semibold`}>
                  บัญชีผู้ใช้ยืนยันตัวตนด้วยบัตรประชาชน
                </TableCell>
                <TableCell className={`text-right font-semibold`}>
                  {summary.verified.toLocaleString() || 0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : (
          <div className="w-full h-72 flex justify-center items-center">
            <Spinner className="w-3 h-3" />
          </div>
        )}
      </div>
      <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
          <p className="font-semibold ">
            ผู้ใช้งานยืนยันตัวตนด้วยบัตรประชาชนแล้ว
          </p>
        </div>
        {verifiedUsers ? (
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">เรียงลำดับตามเดือนเกิด</TableHead>
                <TableHead className="">รหัสผู้ใช้</TableHead>
                <TableHead className="">ชื่อ-นามสกุล</TableHead>
                <TableHead className="">เบอร์</TableHead>
                <TableHead className="">dob</TableHead>
                <TableHead className="">ผู้อนุมัติ</TableHead>
                <TableHead className="">วันที่ใช้สิทธ์</TableHead>
                <TableHead className="">รหัสคำสั่งซื้อคูปอง</TableHead>
                <TableHead className="">คูปอง</TableHead>
                <TableHead className="">สถานะ</TableHead>
                <TableHead className="">คำสั่งซื้ออ้างอิง</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {verifiedUsers
                .sort((a, b) => {
                  const monthA = (a.dob || "").substring(5, 7);
                  const monthB = (b.dob || "").substring(5, 7);

                  return monthA.localeCompare(monthB);
                })
                .map((user, index) => {
                  return (
                    <TableRow>
                      <TableCell className={` font-semibold align-baseline`}>
                        {index + 1}
                      </TableCell>
                      <TableCell className={` font-semibold align-baseline`}>
                        {user.id}
                      </TableCell>
                      <TableCell className={`font-semibold align-baseline`}>
                        {user.firstName} {user.lastName}
                      </TableCell>
                      <TableCell className={` font-semibold align-baseline`}>
                        {user.phone}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        {user.dob}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        #{user.verifiedIdBy?.userId}{" "}
                        {user.verifiedIdBy?.firstName}
                      </TableCell>

                      <TableCell className="font-semibold align-baseline">
                        {user.vipOrder.map((coupon) => (
                          <p>{coupon.createdAtDate}</p>
                        ))}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        {user.vipOrder.map((coupon) => (
                          <p>{coupon.shortId}</p>
                        ))}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        {user.vipOrder.map((coupon) => (
                          <p>{coupon.coupon?.name}</p>
                        ))}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        {user.vipOrder.map((coupon) => (
                          <p>{coupon.coupon?.status}</p>
                        ))}
                      </TableCell>
                      <TableCell className="font-semibold align-baseline">
                        {user.vipOrder.map((coupon) => (
                          <p>
                            {coupon.coupon?.usedBy
                              ? coupon.coupon?.usedBy?.slice(-5)
                              : "-"}
                          </p>
                        ))}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        ) : (
          <div className="w-full h-72 flex justify-center items-center">
            <Spinner className="w-3 h-3" />
          </div>
        )}
      </div>
      {/* <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
          <p className="font-semibold "></p>
        </div>
        {orders ? (
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">ลำดับ</TableHead>
                <TableHead className="">เวลา</TableHead>
                <TableHead className="">รหัสคำสั่งซื้อ</TableHead>
                <TableHead className="">ชื่อ-นามสกุล</TableHead>
                <TableHead className="">เบอร์</TableHead>
                <TableHead className="">dob</TableHead>
                <TableHead className="">dob</TableHead>
                <TableHead className="">สถานะ</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.map((order, index) => {
                return (
                  <TableRow>
                    <TableCell className={` font-semibold`}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={`text-right font-semibold`}>
                      {new Date(order.createdAt).toLocaleDateString("th-TH", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                      })}{" "}
                      น.
                    </TableCell>

                    <TableCell className={` font-semibold`}>
                      {order.shortId}
                    </TableCell>
                    <TableCell className={`text-right font-semibold`}>
                      {order.userData.name} #{order.userData.userId}
                    </TableCell>
                    <TableCell className={`text-right font-semibold`}>
                      {order.userData.phone}
                    </TableCell>
                    <TableCell className="font-semibold align-baseline">
                      <div
                        className={`${
                          order.status === statuses.APPROVE
                            ? "bg-[rgb(59,176,101)]"
                            : order.status === statuses.PAID
                              ? "bg-[#4DA1A9]"
                              : order.status === statuses.PENDING
                                ? "bg-[#FAB12F]"
                                : "bg-[#c15b78]"
                        } min-w-14 w-fit px-3 py-2 text-white text-center rounded-lg mx-auto cursor-pointer `}
                      >
                        {constant.statusesTranslate[order.status]}
                      </div>{" "}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <div className="w-full h-72 flex justify-center items-center">
            <Spinner className="w-3 h-3" />
          </div>
        )}
      </div> */}
    </div>
  );
};
